"use client";

import Image from "next/image";
import classNames from "classnames";
import { CaretSvg } from "../atoms/CaretSvg";
import { useState } from "react";
import { QrCodeModal } from "../organism/QrCodeModal";
import { Box } from "../atoms/Box";
import { Inter } from "next/font/google";
import { trackItemTapped } from "@/utils/mixpanel";
import { MixpanelValues } from "@/constants/mixpanel";

const inter = Inter({ subsets: ["latin"] });

export const GlutenFreeMenu = ({
    pageTitle,
    position,
    menuDataCopy = {},
    isMobile,
    link,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const text = menuDataCopy.sub_title || "Gluten-free options are not marked";
    
    return (
        <div
            id="generic-modal-trigger-menu"
            onClick={() => {
                trackItemTapped(MixpanelValues.ItemTapped.VIEW_MENU);
            }}>
            <Box
                id={`tt-view-menu-button-${pageTitle}-${position}`}
                data-page-name={pageTitle}
                data-position={position}
                data-element-text={text}
                data-device={isMobile ? "mobile" : "desktop"}
            >
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center size-8 md:size-10">
                        <Image
                            width={28}
                            height={29}
                            src="/assets/gluten-free/menu-icon.svg"
                            alt="Gluten Free Menu Icon"
                        />
                    </div>
                    <div
                        className={classNames({
                            "text-[13px] leading-none": true,
                            "md:text-base gap-0 md:leading-[5px]": true,
                            "flex flex-col items-start justify-center": true,
                        })}>
                        <button
                            aria-label={`View ${menuDataCopy.title} menu`}
                            className="font-bold leading-relaxed md:hidden">
                            {menuDataCopy.title || "View menu"}
                        </button>
                        <div
                            className={classNames(
                                inter.className,
                                "font-medium leading-relaxed text-[13px] md:text-lg"
                            )}>
                            {menuDataCopy.sub_title || "GF options marked"}
                        </div>
                    </div>
                </div>
                <div className="flex items-center gap-1 cursor-pointer">
                    {isMobile && menuDataCopy.title ? null : (
                        <button
                            aria-label={`View ${menuDataCopy.title} menu`}
                            className="font-bold leading-relaxed">
                            {menuDataCopy.title}
                        </button>
                    )}
                    <CaretSvg
                        size={24}
                        weight="bold"
                    />
                </div>
            </Box>
            {isModalOpen ? (
                <QrCodeModal
                    link={link}
                    onClose={() => setIsModalOpen(false)}
                />
            ) : null}
        </div>
    );
};
